import constants from "../constants";

const {
  FETCH_NEXT_LIST_TYPE,
  FETCH_NEXT_LIST_DONE,
  FETCH_NEXT_LIST_TYPE_DONE,
  FILTER_LIST_DONE,
  CLEAR_LIST,
  FETCH_LIST_DONE,
} = constants;

// Radium needs the user agent to properly auto prefix
function list(state = {
  items: [],
  next: "",
}, action) {
  switch (action.type) {
    case CLEAR_LIST: {
      return {
        items: [],
        next: state.next,
      };
    }
    case FETCH_NEXT_LIST_TYPE: {
      return {
        ...state,
        filters: {},
      };
    }
    case FETCH_LIST_DONE:
    case FETCH_NEXT_LIST_TYPE_DONE:
    case FETCH_NEXT_LIST_DONE:
    case FILTER_LIST_DONE: {
      const morePois = action.data.pois;

      let common = [];
      if (action.type === FETCH_NEXT_LIST_DONE) {
        common = state.items;
      }

      return {
        items: [...common, ...morePois],
        next: action.data.next,
      };
    }
    default: {
      return state;
    }
  }
}

export default list;



// WEBPACK FOOTER //
// ./assets/list/reducers/list.js